import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from 'react';
import { useLocalStorage } from '@lib/hooks';
import { Country, Currency, getUserTimeZone, isWidget } from '@lib/services';
import { CampaignSetup } from '../campaignSetup';
import { Tip } from './useCheckoutPlan';
import { ProductType } from '../common';
export const FGdefaultCharity = {
    about: '',
    registration_number: '',
    campaign: ProductType.fridayGiving,
    logo_image: '',
    causes: [],
    selectedCauses: [],
    charity_id: '',
    charity_name: '',
    country: Country.GB,
    currency: Currency.GBP,
    gift_aid: false,
    privacy_policy_url: '',
    tax_receipt: false,
    partner: ''
};
export const getFGDefaultPlan = () => {
    const tz = getUserTimeZone();
    return {
        campaign: CampaignSetup.currentFGCampaign,
        chainCode: '',
        causes: {},
        chainCodeCharity: FGdefaultCharity,
        charity: FGdefaultCharity,
        detectedTimezone: tz,
        fridayGivingAmount: 0,
        selectedCauses: [],
        emailOptIn: true,
        charityEmailOptIn: false,
        timezone: tz !== '' ? tz : 'Europe/London',
        evergiveOptIn: '',
        evergiveDonationAmount: 1000,
        donorDetails: {
            addressLine1: '',
            country: '',
            email: '',
            firstName: '',
            lastName: '',
            houseNumber: '',
            postalCode: '',
            isAddressFromLookup: false
        },
        paymentDetails: {
            giftAid: false,
            taxReceipt: false,
            payFees: true,
            payTip: true,
            tipPercent: Tip.TenPercent,
            tipValue: 0
        },
        isFromCharityLandingPage: false,
        partner: '',
        group: ''
    };
};
const checkoutFGPlanContext = createContext({
    plan: getFGDefaultPlan(),
    setPlan: (p) => console.log(p),
    resetPlan: () => { },
    setCharity: (c) => console.log(c)
});
export const useFGCheckoutPlan = () => {
    const result = useContext(checkoutFGPlanContext);
    if (result.plan.campaign !== CampaignSetup.currentFGCampaign) {
        result.resetPlan();
    }
    return result;
};
export const CheckoutFGPlanProvider = ({ children }) => {
    const [plan, setPlan] = useLocalStorage('checkout_fg_plan', getFGDefaultPlan());
    const setCharity = (charity) => {
        const causes = plan.charity.charity_id === charity.charity_id ? plan.causes : {};
        setPlan(Object.assign(Object.assign({}, plan), { charity, causes, selectedCauses: [] }));
    };
    const resetPlan = useCallback(() => {
        if (isWidget) {
            setPlan(Object.assign(Object.assign({}, getFGDefaultPlan()), { charity: plan.charity }));
            return;
        }
        setPlan(getFGDefaultPlan());
    }, [setPlan, plan.charity]);
    const value = {
        plan,
        setPlan,
        resetPlan,
        setCharity
    };
    return _jsx(checkoutFGPlanContext.Provider, Object.assign({ value: value }, { children: children }));
};
//# sourceMappingURL=data:application/json;base64,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